import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Event, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  public logoutLoader: boolean = false;

  constructor(public cookieService: CookieService, public router: Router, public activateRoute: ActivatedRoute, private _snackBar: MatSnackBar, private http: ApiservicesService) {
    window.scroll(0, 0);
  }

  logout() {
     this.cookieService.delete('jwtToken'); 
    this.logoutLoader = true;
     
 
  }

  changePassword() { 
     this.router.navigateByUrl('/change-password');  

   }

   profile() { 
    this.router.navigateByUrl('/account-settings');  

  }


}
